export function CameraIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-camera"
      viewBox="0 0 16 16"
    >
      <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z" />
      <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" />
    </svg>
  );
}

export const SidebarIcon = () => {
  return (
    <>
      <svg
        width="28px"
        height="28px"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 7C4 6.44771 4.44772 6 5 6H24C24.5523 6 25 6.44771 25 7C25 7.55229 24.5523 8 24 8H5C4.44772 8 4 7.55229 4 7Z"
          fill="#000000"
        />
        <path
          d="M4 13.9998C4 13.4475 4.44772 12.9997 5 12.9997L16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15L5 14.9998C4.44772 14.9998 4 14.552 4 13.9998Z"
          fill="#000000"
        />
        <path
          d="M5 19.9998C4.44772 19.9998 4 20.4475 4 20.9998C4 21.552 4.44772 21.9997 5 21.9997H22C22.5523 21.9997 23 21.552 23 20.9998C23 20.4475 22.5523 19.9998 22 19.9998H5Z"
          fill="#000000"
        />
      </svg>
    </>
  );
};

export const EyeIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.6">
          <path
            d="M3 13C6.6 5 17.4 5 21 13"
            stroke="#42B03A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 17C11.606 17 11.2159 16.9224 10.8519 16.7716C10.488 16.6209 10.1573 16.3999 9.87868 16.1213C9.6001 15.8427 9.37913 15.512 9.22836 15.1481C9.0776 14.7841 9 14.394 9 14C9 13.606 9.0776 13.2159 9.22836 12.8519C9.37913 12.488 9.6001 12.1573 9.87868 11.8787C10.1573 11.6001 10.488 11.3791 10.8519 11.2284C11.2159 11.0776 11.606 11 12 11C12.7956 11 13.5587 11.3161 14.1213 11.8787C14.6839 12.4413 15 13.2044 15 14C15 14.7956 14.6839 15.5587 14.1213 16.1213C13.5587 16.6839 12.7956 17 12 17Z"
            fill="#42B03A"
            stroke="#42B03A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </>
  );
};
export const HideIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.22022 2.22007C2.0932 2.34706 2.01597 2.51541 2.00258 2.69452C1.98918 2.87363 2.04051 3.0516 2.14722 3.19607L2.22022 3.28007L6.25422 7.31507C4.28816 8.6946 2.88427 10.7356 2.29922 13.0651C2.2542 13.2569 2.28646 13.4587 2.38903 13.6269C2.49159 13.7951 2.65623 13.9162 2.84736 13.964C3.03848 14.0118 3.24075 13.9825 3.41044 13.8824C3.58013 13.7823 3.70362 13.6195 3.75422 13.4291C4.27403 11.3615 5.55181 9.56474 7.33422 8.39507L9.14422 10.2051C8.42122 10.9606 8.02281 11.9692 8.03434 13.0148C8.04588 14.0604 8.46643 15.06 9.20592 15.7994C9.94542 16.5387 10.945 16.9591 11.9907 16.9704C13.0363 16.9818 14.0449 16.5832 14.8002 15.8601L20.7192 21.7801C20.853 21.9143 21.0327 21.9928 21.2221 21.9999C21.4115 22.0071 21.5965 21.9422 21.7401 21.8185C21.8836 21.6947 21.9749 21.5212 21.9957 21.3328C22.0166 21.1444 21.9653 20.9552 21.8522 20.8031L21.7792 20.7191L15.6662 14.6051L15.6672 14.6031L8.71722 7.65707L8.71922 7.65507L7.58622 6.52507L3.28022 2.22007C3.1396 2.07962 2.94897 2.00073 2.75022 2.00073C2.55147 2.00073 2.36085 2.07962 2.22022 2.22007ZM12.0002 5.50007C11.0002 5.50007 10.0302 5.64807 9.11122 5.92507L10.3482 7.16107C12.4878 6.73743 14.7083 7.15216 16.5507 8.3195C18.3931 9.48685 19.7165 11.3175 20.2472 13.4331C20.299 13.622 20.4227 13.7832 20.5918 13.8821C20.7609 13.981 20.962 14.0098 21.1521 13.9624C21.3421 13.915 21.5061 13.7951 21.6089 13.6283C21.7117 13.4616 21.7452 13.2612 21.7022 13.0701C21.1604 10.9073 19.9114 8.98758 18.1535 7.61601C16.3957 6.24444 14.2298 5.49969 12.0002 5.50007ZM12.1952 9.01007L15.9962 12.8101C15.9471 11.818 15.5308 10.8796 14.8283 10.1773C14.1258 9.47501 13.1873 9.05898 12.1952 9.01007Z"
          fill="#88CD83"
        />
      </svg>
    </>
  );
};
export const Dashboard = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.98349 8.06594H3.48349C2.77584 8.06594 2.2002 7.49029 2.2002 6.78251V3.48251C2.2002 2.77487 2.77584 2.19922 3.48349 2.19922H8.98349C9.69127 2.19922 10.2669 2.77487 10.2669 3.48251V6.78251C10.2669 7.49029 9.69127 8.06594 8.98349 8.06594ZM3.48349 3.29922C3.38237 3.29922 3.3002 3.3814 3.3002 3.48251V6.78251C3.3002 6.88376 3.38237 6.96594 3.48349 6.96594H8.98349C9.08474 6.96594 9.16692 6.88376 9.16692 6.78251V3.48251C9.16692 3.3814 9.08474 3.29922 8.98349 3.29922H3.48349Z"
          fill="#32603A"
        />
        <path
          d="M8.98349 19.798H3.48349C2.77584 19.798 2.2002 19.2223 2.2002 18.5147V10.8147C2.2002 10.1069 2.77584 9.53125 3.48349 9.53125H8.98349C9.69127 9.53125 10.2669 10.1069 10.2669 10.8147V18.5147C10.2669 19.2223 9.69127 19.798 8.98349 19.798ZM3.48349 10.6313C3.38237 10.6313 3.3002 10.7134 3.3002 10.8147V18.5147C3.3002 18.6158 3.38237 18.698 3.48349 18.698H8.98349C9.08474 18.698 9.16692 18.6158 9.16692 18.5147V10.8147C9.16692 10.7134 9.08474 10.6313 8.98349 10.6313H3.48349Z"
          fill="#32603A"
        />
        <path
          d="M18.5168 19.7984H13.0168C12.309 19.7984 11.7334 19.2227 11.7334 18.5151V15.2151C11.7334 14.5073 12.309 13.9316 13.0168 13.9316H18.5168C19.2245 13.9316 19.8001 14.5073 19.8001 15.2151V18.5151C19.8001 19.2227 19.2245 19.7984 18.5168 19.7984ZM13.0168 15.0316C12.9156 15.0316 12.8334 15.1138 12.8334 15.2151V18.5151C12.8334 18.6162 12.9156 18.6984 13.0168 18.6984H18.5168C18.6179 18.6984 18.7001 18.6162 18.7001 18.5151V15.2151C18.7001 15.1138 18.6179 15.0316 18.5168 15.0316H13.0168Z"
          fill="#32603A"
        />
        <path
          d="M18.5168 12.4659H13.0168C12.309 12.4659 11.7334 11.8903 11.7334 11.1825V3.48251C11.7334 2.77487 12.309 2.19922 13.0168 2.19922H18.5168C19.2245 2.19922 19.8001 2.77487 19.8001 3.48251V11.1825C19.8001 11.8903 19.2245 12.4659 18.5168 12.4659ZM13.0168 3.29922C12.9156 3.29922 12.8334 3.3814 12.8334 3.48251V11.1825C12.8334 11.2838 12.9156 11.3659 13.0168 11.3659H18.5168C18.6179 11.3659 18.7001 11.2838 18.7001 11.1825V3.48251C18.7001 3.3814 18.6179 3.29922 18.5168 3.29922H13.0168Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Customers = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0395 10.6373C12.3498 10.6373 13.4843 10.1674 14.4115 9.24014C15.3384 8.31308 15.8085 7.17876 15.8085 5.86831C15.8085 4.55831 15.3386 3.42384 14.4113 2.49647C13.4841 1.56956 12.3497 1.09961 11.0395 1.09961C9.72905 1.09961 8.59474 1.56956 7.66767 2.49662C6.74061 3.42369 6.27051 4.55816 6.27051 5.86831C6.27051 7.17876 6.74061 8.31323 7.66767 9.2403C8.59504 10.1672 9.72951 10.6373 11.0395 10.6373ZM8.48824 3.31704C9.19958 2.60569 10.034 2.25991 11.0395 2.25991C12.0448 2.25991 12.8794 2.60569 13.5909 3.31704C14.3023 4.02853 14.6482 4.86315 14.6482 5.86831C14.6482 6.87377 14.3023 7.70823 13.5909 8.41973C12.8794 9.13123 12.0448 9.47701 11.0395 9.47701C10.0343 9.47701 9.19989 9.13108 8.48824 8.41973C7.77674 7.70838 7.43081 6.87377 7.43081 5.86831C7.43081 4.86315 7.77674 4.02853 8.48824 3.31704Z"
          fill="#32603A"
        />
        <path
          d="M19.3839 16.3251C19.3572 15.9393 19.3031 15.5184 19.2235 15.074C19.1431 14.6263 19.0396 14.203 18.9158 13.8161C18.7877 13.4163 18.6138 13.0214 18.3985 12.643C18.1754 12.2502 17.9132 11.9082 17.6189 11.6268C17.3112 11.3324 16.9344 11.0957 16.4988 10.923C16.0646 10.7512 15.5835 10.6642 15.0688 10.6642C14.8667 10.6642 14.6712 10.7472 14.2937 10.9929C14.0614 11.1445 13.7896 11.3197 13.4863 11.5135C13.2269 11.6788 12.8756 11.8336 12.4416 11.9738C12.0182 12.1108 11.5882 12.1803 11.1638 12.1803C10.7396 12.1803 10.3097 12.1108 9.88593 11.9738C9.45238 11.8337 9.10086 11.6789 8.84194 11.5136C8.54148 11.3216 8.26957 11.1464 8.03377 10.9928C7.65657 10.747 7.46109 10.6641 7.25897 10.6641C6.74416 10.6641 6.26318 10.7512 5.82918 10.9231C5.39382 11.0955 5.01692 11.3322 4.70891 11.6269C4.41464 11.9085 4.1524 12.2504 3.92943 12.643C3.71447 13.0214 3.54045 13.4161 3.41235 13.8163C3.28863 14.2031 3.18515 14.6263 3.10479 15.074C3.02503 15.5178 2.9711 15.9388 2.94436 16.3255C2.91808 16.7037 2.90479 17.0972 2.90479 17.4948C2.90479 18.5283 3.23334 19.3651 3.88124 19.9821C4.52114 20.5911 5.36769 20.8998 6.39747 20.8998H15.9312C16.9607 20.8998 17.8073 20.5911 18.4473 19.9821C19.0954 19.3655 19.4239 18.5285 19.4239 17.4946C19.4238 17.0957 19.4103 16.7021 19.3839 16.3251ZM17.6473 19.1415C17.2245 19.5439 16.6631 19.7395 15.9311 19.7395H6.39747C5.66528 19.7395 5.10393 19.5439 4.68126 19.1416C4.2666 18.7469 4.06509 18.2081 4.06509 17.4948C4.06509 17.1238 4.07732 16.7574 4.10179 16.4058C4.12566 16.0607 4.17445 15.6817 4.24681 15.279C4.31826 14.8813 4.4092 14.508 4.51736 14.1701C4.62114 13.846 4.76269 13.5252 4.93822 13.2161C5.10575 12.9215 5.2985 12.6688 5.51119 12.4652C5.71014 12.2747 5.9609 12.1188 6.25638 12.0019C6.52965 11.8937 6.83676 11.8345 7.17015 11.8256C7.21078 11.8472 7.28314 11.8884 7.40037 11.9649C7.63889 12.1203 7.91382 12.2977 8.21776 12.4918C8.56036 12.7102 9.00177 12.9075 9.52912 13.0777C10.0683 13.2521 10.6181 13.3406 11.1639 13.3406C11.7097 13.3406 12.2597 13.2521 12.7985 13.0779C13.3263 12.9073 13.7676 12.7102 14.1107 12.4915C14.4217 12.2927 14.6889 12.1205 14.9274 11.9649C15.0447 11.8886 15.117 11.8472 15.1577 11.8256C15.4912 11.8345 15.7983 11.8937 16.0717 12.0019C16.3671 12.1188 16.6178 12.2748 16.8168 12.4652C17.0295 12.6687 17.2222 12.9214 17.3897 13.2163C17.5654 13.5252 17.7071 13.8462 17.8107 14.1699C17.9191 14.5083 18.0101 14.8814 18.0814 15.2788C18.1537 15.6823 18.2026 16.0615 18.2265 16.4059V16.4062C18.2511 16.7565 18.2635 17.1227 18.2636 17.4948C18.2635 18.2082 18.062 18.7469 17.6473 19.1415Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Payments = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.215 20.625H4.785C3.27937 20.625 2.0625 19.525 2.0625 18.1706V3.82938C2.0625 2.475 3.28625 1.375 4.785 1.375H17.215C18.7138 1.375 19.9375 2.475 19.9375 3.82938V18.1706C19.9375 19.525 18.7138 20.625 17.215 20.625ZM4.785 2.75C4.0425 2.75 3.4375 3.23125 3.4375 3.82938V18.1706C3.4375 18.7688 4.0425 19.25 4.785 19.25H17.215C17.9575 19.25 18.5625 18.7619 18.5625 18.1706V3.82938C18.5625 3.23125 17.9575 2.75 17.215 2.75H4.785ZM16.5 13.0625H5.5V14.4375H16.5V13.0625ZM16.5 15.8125H5.5V17.1875H16.5V15.8125ZM11.1169 7.35625C10.9244 7.32188 10.2919 7.18437 10.2919 6.81312C10.2919 6.52437 10.615 6.28375 11 6.28375C11.385 6.28375 11.7081 6.52437 11.7081 6.81312H13.0831C13.0831 5.98125 12.4987 5.28 11.6875 5.01875V4.13875H10.3125V5.01875C8.23625 5.72 8.54562 8.43563 10.9037 8.71063C11.3025 8.76562 11.7013 8.97188 11.7013 9.25375C11.6806 9.94812 10.3125 9.94812 10.2919 9.25375H8.91688C8.91688 10.0856 9.50125 10.7869 10.3125 11.0481V11.9281H11.6875V11.0481C13.7844 10.34 13.4131 7.60375 11.1169 7.35625Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Plan = () => {
  return (
    <>
      <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Document outline */}
      <rect
        x="4"
        y="2"
        width="14"
        height="18"
        rx="2"
        stroke="#6B7280"
        strokeWidth="1.5"
      />
      {/* Header line */}
      <path
        d="M7 6H15"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Content lines */}
      <path
        d="M7 9H13M7 12H15M7 15H11"
        stroke="#6B7280"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
    </>
  );
};

export const Orders = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_553_6278)">
          <path
            d="M11.0501 3.31583H13.6135L12.6427 4.28834C12.3912 4.54028 12.3916 4.94831 12.6435 5.19991C12.895 5.45085 13.3032 5.45135 13.5549 5.19907L15.6225 3.12801C15.8774 2.87272 15.8741 2.45327 15.6077 2.20251L13.5549 0.146216C13.3035 -0.105722 12.8955 -0.106058 12.6435 0.145377C12.3916 0.396979 12.3912 0.805014 12.6427 1.05695L13.6108 2.02677C10.6901 2.02677 11.0543 2.0266 11.0225 2.0266C4.20871 2.0266 -0.116361 9.44224 3.30033 15.4028C3.47724 15.7115 3.87084 15.8186 4.18001 15.6415C4.48885 15.4644 4.5956 15.0706 4.41869 14.7618C1.47818 9.63208 5.24215 3.28663 11.0501 3.31583Z"
            fill="#32603A"
          />
          <path
            d="M18.7623 6.51155C18.5853 6.20288 18.1914 6.09596 17.8826 6.27287C17.5737 6.44995 17.467 6.84389 17.6441 7.15272C20.5622 12.2435 16.8792 18.5987 11.0314 18.5987H8.44908L9.41991 17.6262C9.67151 17.3743 9.67118 16.9662 9.41924 16.7146C9.1673 16.4632 8.7591 16.4635 8.50766 16.7155L6.44012 18.7865C6.18735 19.0396 6.186 19.4598 6.45573 19.7129L8.50766 21.7683C8.7591 22.0201 9.16713 22.0208 9.41924 21.7692C9.67118 21.5176 9.67151 21.1095 9.42008 20.8576L8.45194 19.8878H11.0395C17.8567 19.8876 22.1783 12.4709 18.7623 6.51155Z"
            fill="#32603A"
          />
          <path
            d="M10.3867 9.02344H12.9648C13.3207 9.02344 13.6094 8.73474 13.6094 8.37891C13.6094 8.0229 13.3207 7.73438 12.9648 7.73438H11.6758V7.08984C11.6758 6.73384 11.3871 6.44531 11.0313 6.44531C10.6752 6.44531 10.3867 6.73384 10.3867 7.08984V7.73438C9.32039 7.73438 8.45313 8.60181 8.45313 9.66797C8.45313 10.7341 9.32039 11.6016 10.3867 11.6016H11.6756C12.0311 11.6016 12.3203 11.8906 12.3203 12.2461C12.3203 12.6016 12.0328 12.8908 11.6756 12.8908C11.0096 12.8908 11.0313 12.8906 11.0313 12.8906C11.0302 12.8906 11.0292 12.8908 11.0282 12.8908C11.0032 12.8908 9.08322 12.8906 9.09766 12.8906C8.74165 12.8906 8.45313 13.1792 8.45313 13.535C8.45296 13.891 8.74149 14.1795 9.09749 14.1797H10.3867V14.8242C10.3867 15.1801 10.6752 15.4688 11.0313 15.4688C11.3871 15.4688 11.6758 15.1801 11.6758 14.8242V14.1799C12.7443 14.1799 13.6094 13.3153 13.6094 12.2461C13.6094 11.1799 12.7418 10.3125 11.6756 10.3125H10.3867C10.0312 10.3125 9.74219 10.0233 9.74219 9.66797C9.74219 9.31247 10.0312 9.02344 10.3867 9.02344Z"
            fill="#32603A"
          />
        </g>
        <defs>
          <clipPath id="clip0_553_6278">
            <rect width="22" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const Products = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.5599 10.9995C20.5599 16.2708 16.2713 20.5595 10.9999 20.5595C5.7286 20.5595 1.43994 16.2708 1.43994 10.9995C1.43994 10.6692 1.70722 10.402 2.03744 10.402C2.36766 10.402 2.63494 10.6692 2.63494 10.9995C2.63494 15.612 6.38744 19.3645 10.9999 19.3645C15.6124 19.3645 19.3649 15.612 19.3649 10.9995C19.3649 6.38695 15.6124 2.63445 10.9999 2.63445C8.77664 2.63445 6.71268 3.49864 5.15998 5.02445H7.41494C7.74516 5.02445 8.01244 5.29173 8.01244 5.62195C8.01244 5.95217 7.74516 6.21945 7.41494 6.21945H3.82994C3.49972 6.21945 3.23244 5.95217 3.23244 5.62195V2.03695C3.23244 1.70673 3.49972 1.43945 3.82994 1.43945C4.16016 1.43945 4.42744 1.70673 4.42744 2.03695V4.07522C6.19027 2.39266 8.50657 1.43945 10.9999 1.43945C16.2713 1.43945 20.5599 5.72811 20.5599 10.9995ZM16.3774 8.60945V13.987C16.3774 14.2361 16.2229 14.459 15.9901 14.5466L11.2101 16.3391C11.1423 16.3642 11.071 16.377 10.9999 16.377C10.9288 16.377 10.8575 16.3642 10.7898 16.3391L6.00982 14.5466C5.77699 14.459 5.62244 14.2361 5.62244 13.987V8.60945C5.62244 8.3603 5.77699 8.13743 6.00982 8.04979L10.7898 6.2573C10.9253 6.20711 11.0746 6.20711 11.2099 6.2573L15.9899 8.04979C16.2229 8.13743 16.3774 8.3603 16.3774 8.60945ZM7.92142 8.60945L10.9999 9.76362L14.0785 8.60945L10.9999 7.45528L7.92142 8.60945ZM6.81744 13.5727L10.4024 14.9171V10.8162L6.81744 9.47185V13.5727ZM15.1824 13.5727V9.47185L11.5974 10.8162V14.9171L15.1824 13.5727Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Reports = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.3789 2.0959H15.1787C14.5981 1.42535 13.7425 1 12.7891 1H9.625C8.67156 1 7.81594 1.42535 7.23535 2.0959H5.03516C4.0659 2.0959 3.27734 2.88602 3.27734 3.85715V19.2388C3.27734 20.2099 4.0659 21 5.03516 21H17.3789C18.3482 21 19.1367 20.2099 19.1367 19.2388V3.85715C19.1367 2.88598 18.3482 2.0959 17.3789 2.0959ZM9.625 2.17418H12.7891C13.6944 2.17418 14.4463 2.78023 14.6934 3.58316H7.7207C7.96734 2.78164 8.71824 2.17418 9.625 2.17418ZM17.9648 19.2388C17.9648 19.5625 17.702 19.8258 17.3789 19.8258H5.03516C4.71207 19.8258 4.44922 19.5625 4.44922 19.2388V3.85715C4.44922 3.53344 4.71207 3.27008 5.03516 3.27008H6.59164C6.50707 3.55562 6.46094 3.85758 6.46094 4.17027C6.46094 4.49449 6.72328 4.75734 7.04688 4.75734H15.3672C15.6908 4.75734 15.9531 4.49449 15.9531 4.17027C15.9531 3.85758 15.907 3.55562 15.8224 3.27008H17.3789C17.702 3.27008 17.9648 3.53344 17.9648 3.85715V19.2388Z"
          fill="#32603A"
        />
        <path
          d="M8.31877 12.6661L7.45705 13.5295L7.24635 13.3184C7.01756 13.0891 6.64654 13.0891 6.41771 13.3184C6.18889 13.5476 6.18889 13.9194 6.41771 14.1486L7.04271 14.7748C7.2715 15.0041 7.64252 15.0041 7.87135 14.7748L9.14736 13.4963C9.37619 13.2671 9.37619 12.8953 9.14736 12.6661C8.91857 12.4368 8.54756 12.4368 8.31877 12.6661Z"
          fill="#32603A"
        />
        <path
          d="M15.543 13.1328H10.8164C10.4928 13.1328 10.2305 13.3957 10.2305 13.7199C10.2305 14.0441 10.4928 14.307 10.8164 14.307H15.543C15.8666 14.307 16.1289 14.0441 16.1289 13.7199C16.1289 13.3957 15.8666 13.1328 15.543 13.1328Z"
          fill="#32603A"
        />
        <path
          d="M8.31877 16.0314L7.45705 16.8947L7.24635 16.6836C7.01756 16.4543 6.64654 16.4543 6.41771 16.6836C6.18889 16.9129 6.18889 17.2846 6.41771 17.5139L7.04271 18.1401C7.2715 18.3693 7.64252 18.3694 7.87135 18.1401L9.14736 16.8615C9.37619 16.6323 9.37619 16.2606 9.14736 16.0313C8.91857 15.8021 8.54756 15.8021 8.31877 16.0314Z"
          fill="#32603A"
        />
        <path
          d="M15.543 16.498H10.8164C10.4928 16.498 10.2305 16.7609 10.2305 17.0851C10.2305 17.4093 10.4928 17.6722 10.8164 17.6722H15.543C15.8666 17.6722 16.1289 17.4093 16.1289 17.0851C16.1289 16.7609 15.8666 16.498 15.543 16.498Z"
          fill="#32603A"
        />
        <path
          d="M12.3245 10.4179L14.1367 8.60207V8.67203C14.1367 8.99625 14.3991 9.2591 14.7227 9.2591C15.0463 9.2591 15.3086 8.99625 15.3086 8.67203C15.3086 7.01137 15.3113 7.16598 15.3019 7.10039C15.2604 6.81316 15.0147 6.59758 14.7225 6.59766H13.2383C12.9147 6.59766 12.6524 6.86051 12.6524 7.18473C12.6524 7.50895 12.9147 7.7718 13.2383 7.7718H13.3081L11.9102 9.17246L10.137 7.39582C9.90818 7.16652 9.53717 7.16652 9.30834 7.39582L7.19896 9.50934C6.97014 9.73859 6.97014 10.1103 7.19896 10.3396C7.42775 10.5689 7.79877 10.5689 8.0276 10.3396L9.72268 8.64121L11.4959 10.4179C11.7246 10.6471 12.0957 10.6471 12.3245 10.4179Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Lable = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.9911 9.76418L20.5257 3.71191C20.4331 2.50733 19.4916 1.56589 18.2871 1.47328L12.2348 1.00788C11.5051 0.951827 10.8459 1.19568 10.3285 1.71315L1.68496 10.3567C1.24327 10.7984 1 11.3874 1 12.0153C1 12.6432 1.24327 13.2323 1.68496 13.674L8.32498 20.314C8.7823 20.7714 9.38285 21 9.98364 21C10.5842 21 11.1851 20.7713 11.6423 20.314L20.2859 11.6705C20.8033 11.153 21.0472 10.4938 20.9911 9.76418ZM19.402 10.7867L10.7585 19.4302C10.3312 19.8574 9.63604 19.8574 9.20884 19.4302L2.56882 12.7902C2.36317 12.5845 2.24993 12.3094 2.24993 12.0153C2.24993 11.7213 2.36317 11.4461 2.56878 11.2405L11.2124 2.59697C11.4452 2.36405 11.7141 2.24996 12.0316 2.24996C12.0668 2.24996 12.1026 2.25132 12.139 2.25414L18.1913 2.71954C18.7768 2.7645 19.2344 3.22217 19.2794 3.80768L19.7448 9.86C19.7729 10.2248 19.6608 10.5279 19.402 10.7867ZM15.6376 3.98674C14.3282 3.98674 13.263 5.05199 13.263 6.36137C13.263 7.67075 14.3282 8.736 15.6376 8.73604C16.947 8.736 18.0123 7.67075 18.0123 6.36137C18.0123 5.05199 16.947 3.98674 15.6376 3.98674ZM15.6376 7.48611C15.0175 7.48607 14.5129 6.98153 14.5129 6.36137C14.5129 5.74121 15.0175 5.23667 15.6376 5.23667C16.2578 5.23667 16.7623 5.74121 16.7623 6.36137C16.7623 6.98153 16.2578 7.48607 15.6376 7.48611Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Data = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.1598 5.0066H11.9392C11.9307 5.0066 11.9231 5.00175 11.9195 4.99395L11.2779 3.60704C11.0969 3.21449 10.7146 2.96094 10.3039 2.96094H6.54333C5.94467 2.96094 5.45766 3.48011 5.45766 4.11827V5.25266H4.39283C3.79432 5.25266 3.30731 5.77168 3.30731 6.40969V7.54408H2.24289C1.64424 7.54408 1.15723 8.06311 1.15723 8.70112V18.0639C1.15723 18.7019 1.64424 19.2209 2.24289 19.2209H13.8595C14.4582 19.2209 14.9452 18.7019 14.9452 18.0639V16.9294H16.0097C16.6084 16.9294 17.0954 16.4103 17.0954 15.7725V14.6381H18.1598C18.7585 14.6381 19.2455 14.1191 19.2455 13.481V6.16393C19.2455 5.52577 18.7585 5.0066 18.1598 5.0066ZM13.8595 18.087H2.24289C2.23102 18.087 2.22123 18.0767 2.22123 18.0639V8.70112C2.22123 8.68832 2.23102 8.67803 2.24289 8.67803H6.00374C6.00732 8.67803 6.01077 8.67935 6.01381 8.68112C6.01422 8.68141 6.01478 8.68126 6.01519 8.68156C6.01643 8.68244 6.01712 8.68406 6.01823 8.68509C6.02002 8.687 6.02209 8.68862 6.02319 8.69097L6.66504 10.0783C6.84928 10.4763 7.22244 10.7237 7.63879 10.7237H13.8595C13.8624 10.7237 13.8653 10.7243 13.8679 10.7255C13.8757 10.729 13.8811 10.7372 13.8811 10.7468C13.8811 14.7455 13.8812 18.0274 13.8812 18.0639C13.8812 18.0767 13.8715 18.087 13.8595 18.087ZM16.0314 15.7725C16.0314 15.7851 16.0217 15.7954 16.0099 15.7954H14.9452V10.7468C14.9452 10.1086 14.458 9.5896 13.8594 9.5896H7.63879C7.63078 9.5896 7.62306 9.58445 7.61947 9.57666L6.97748 8.1893C6.79339 7.79176 6.42036 7.54408 6.00387 7.54408H4.3713V6.40969C4.3713 6.3969 4.38096 6.3866 4.39283 6.3866H8.15381C8.16209 6.3866 8.16955 6.39146 8.17327 6.39969L8.81526 7.78705C8.99963 8.18503 9.37265 8.43227 9.78887 8.43227H16.0099C16.0217 8.43227 16.0314 8.44256 16.0314 8.45536V15.7725ZM18.1815 13.481C18.1815 13.4938 18.1718 13.5041 18.1598 13.5041H17.0954V8.45536C17.0954 7.81735 16.6085 7.29832 16.0099 7.29832H9.78887C9.78073 7.29832 9.77314 7.29317 9.76941 7.28523L9.12756 5.89831C8.9436 5.50004 8.57044 5.25266 8.15381 5.25266H6.52166V4.11827C6.52166 4.10533 6.53132 4.09488 6.54319 4.09488H10.3038C10.3119 4.09488 10.3195 4.09974 10.3232 4.10783L10.9652 5.49562C11.1494 5.89331 11.5226 6.14055 11.9392 6.14055H18.1598C18.1717 6.14055 18.1814 6.15099 18.1814 6.16408V13.481H18.1815Z"
          fill="#32603A"
        />
        <path
          d="M10.6116 15.8418C10.3178 15.8418 10.0796 16.08 10.0796 16.3738V16.6814C10.0796 16.9752 10.3178 17.2134 10.6116 17.2134C10.9054 17.2134 11.1436 16.9752 11.1436 16.6814V16.3738C11.1436 16.08 10.9054 15.8418 10.6116 15.8418Z"
          fill="#32603A"
        />
        <path
          d="M12.1619 15.8418C11.8681 15.8418 11.6299 16.08 11.6299 16.3738V16.6814C11.6299 16.9752 11.8681 17.2134 12.1619 17.2134C12.4557 17.2134 12.6939 16.9752 12.6939 16.6814V16.3738C12.6939 16.08 12.4557 15.8418 12.1619 15.8418Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Printer = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.0222 6.29882H17.0071V2.63335C17.0071 2.28359 16.7235 2 16.3737 2H5.62627C5.27651 2 4.99292 2.28355 4.99292 2.63335V6.29882H2.97777C2.16292 6.29882 1.5 6.96178 1.5 7.77663V14.1484C1.5 14.9632 2.16292 15.6262 2.97777 15.6262H4.99303V19.0259C4.99303 19.3756 5.27658 19.6592 5.62638 19.6592H16.3736C16.7234 19.6592 17.007 19.3757 17.007 19.0259V15.6262H19.0222C19.8371 15.6262 20.5 14.9632 20.5 14.1484V7.77663C20.5 6.96182 19.8371 6.29882 19.0222 6.29882ZM6.25957 3.26669H15.7404V6.29882H6.25957V3.26669ZM15.7403 18.3925H6.25972C6.25972 18.2688 6.25972 13.3641 6.25972 13.211H15.7403C15.7403 13.368 15.7403 18.2735 15.7403 18.3925ZM19.2333 14.1484C19.2333 14.2648 19.1386 14.3595 19.0222 14.3595H17.007V12.5778C17.007 12.228 16.7234 11.9444 16.3736 11.9444H5.62638C5.27662 11.9444 4.99303 12.228 4.99303 12.5778V14.3595H2.97777C2.86136 14.3595 2.76665 14.2648 2.76665 14.1484V7.77667C2.76665 7.66026 2.86136 7.56555 2.97777 7.56555C3.46368 7.56555 18.5478 7.56555 19.0222 7.56555C19.1386 7.56555 19.2333 7.66026 19.2333 7.77667V14.1484Z"
          fill="#32603A"
        />
        <path
          d="M16.3754 8.75116H14.7632C14.4135 8.75116 14.1299 9.03471 14.1299 9.3845C14.1299 9.7343 14.4134 10.0179 14.7632 10.0179H16.3754C16.7251 10.0179 17.0087 9.7343 17.0087 9.3845C17.0087 9.03471 16.7252 8.75116 16.3754 8.75116Z"
          fill="#32603A"
        />
        <path
          d="M13.7443 16.1674H8.25542C7.90566 16.1674 7.62207 16.451 7.62207 16.8007C7.62207 17.1505 7.90562 17.4341 8.25542 17.4341H13.7443C14.0941 17.4341 14.3776 17.1505 14.3776 16.8007C14.3776 16.451 14.0941 16.1674 13.7443 16.1674Z"
          fill="#32603A"
        />
        <path
          d="M13.7443 14.1697H8.25542C7.90566 14.1697 7.62207 14.4532 7.62207 14.803C7.62207 15.1528 7.90562 15.4364 8.25542 15.4364H13.7443C14.0941 15.4364 14.3776 15.1528 14.3776 14.803C14.3776 14.4532 14.0941 14.1697 13.7443 14.1697Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Temperature = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0015 20.336C9.70139 20.336 8.5985 19.8831 7.69281 18.9772C6.78693 18.0715 6.33398 16.9686 6.33398 15.6685C6.33398 14.8249 6.54567 14.0518 6.96906 13.3494C7.39244 12.6469 7.95866 12.0736 8.66773 11.6294V3.99977C8.66773 3.34145 8.89216 2.78797 9.34102 2.3393C9.78968 1.89045 10.3432 1.66602 11.0015 1.66602C11.6598 1.66602 12.2133 1.89045 12.6619 2.3393C13.1108 2.78797 13.3352 3.34145 13.3352 3.99977V11.6294C14.0443 12.0736 14.6068 12.6469 15.0228 13.3494C15.4386 14.0518 15.654 14.8249 15.669 15.6685C15.654 16.9686 15.1936 18.0715 14.2877 18.9772C13.382 19.8831 12.2866 20.336 11.0015 20.336ZM11.0015 19.1691C11.9739 19.1691 12.8004 18.8288 13.4811 18.1481C14.1618 17.4674 14.5021 16.6409 14.5021 15.6685C14.5021 15.1045 14.3806 14.5794 14.1375 14.0932C13.8944 13.607 13.5492 13.1986 13.1019 12.868L12.1684 12.1679V3.99977C12.1684 3.66915 12.0565 3.39202 11.8329 3.16837C11.6092 2.94472 11.3321 2.83289 11.0015 2.83289C10.6709 2.83289 10.3937 2.94472 10.1701 3.16837C9.94643 3.39202 9.83461 3.66915 9.83461 3.99977V12.1679L8.90111 12.868C8.45381 13.1986 8.10861 13.607 7.86551 14.0932C7.62241 14.5794 7.50086 15.1045 7.50086 15.6685C7.50086 16.6409 7.8412 17.4674 8.52187 18.1481C9.20255 18.8288 10.0291 19.1691 11.0015 19.1691Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Notifications = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.1758 11.268V9.39844C17.1758 6.67102 15.3629 4.35934 12.879 3.6043V2.75781C12.879 1.78855 12.0904 1 11.1211 1C10.1519 1 9.36333 1.78855 9.36333 2.75781V3.6043C6.87934 4.35934 5.06645 6.67098 5.06645 9.39844V11.268C5.06645 13.6638 4.15325 15.9355 2.49508 17.6648C2.33258 17.8342 2.28692 18.0843 2.37903 18.3002C2.47114 18.5161 2.68325 18.6562 2.91801 18.6562H8.2504C8.52258 19.9919 9.70633 21 11.1211 21C12.536 21 13.7197 19.9919 13.9919 18.6562H19.3243C19.559 18.6562 19.7711 18.5161 19.8632 18.3002C19.9553 18.0843 19.9097 17.8342 19.7472 17.6648C18.089 15.9355 17.1758 13.6638 17.1758 11.268ZM10.5352 2.75781C10.5352 2.43473 10.7981 2.17188 11.1211 2.17188C11.4442 2.17188 11.7071 2.43473 11.7071 2.75781V3.37219C11.5142 3.35359 11.3188 3.34375 11.1211 3.34375C10.9235 3.34375 10.7281 3.35359 10.5352 3.37219V2.75781ZM11.1211 19.8281C10.3573 19.8281 9.70598 19.3382 9.46411 18.6562H12.7782C12.5363 19.3382 11.885 19.8281 11.1211 19.8281ZM4.1809 17.4844C5.51532 15.6956 6.23833 13.5309 6.23833 11.268V9.39844C6.23833 6.70605 8.42876 4.51562 11.1211 4.51562C13.8135 4.51562 16.004 6.70605 16.004 9.39844V11.268C16.004 13.5309 16.727 15.6956 18.0614 17.4844H4.1809Z"
          fill="#32603A"
        />
        <path
          d="M18.7386 9.39841C18.7386 9.72201 19.0009 9.98435 19.3245 9.98435C19.6481 9.98435 19.9104 9.72201 19.9104 9.39841C19.9104 7.05076 18.9962 4.84361 17.3362 3.18357C17.1074 2.95478 16.7364 2.95474 16.5076 3.18357C16.2787 3.4124 16.2787 3.78337 16.5076 4.0122C17.9463 5.45091 18.7386 7.36376 18.7386 9.39841Z"
          fill="#32603A"
        />
        <path
          d="M2.91797 9.98433C3.24156 9.98433 3.50391 9.72198 3.50391 9.39839C3.50391 7.36378 4.29625 5.45093 5.73492 4.01222C5.96375 3.78339 5.96375 3.41241 5.73492 3.18358C5.50613 2.95476 5.13512 2.95476 4.90629 3.18358C3.24625 4.84362 2.33203 7.05073 2.33203 9.39839C2.33203 9.72198 2.59437 9.98433 2.91797 9.98433Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Support = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7917 6.41667H9.57764V5.5H19.25C19.5031 5.5 19.7084 5.7052 19.7084 5.95833V9.71969C19.7084 9.97288 19.5031 10.178 19.25 10.178H18.8233C18.3694 10.178 18.0014 10.546 18.0014 10.9999C18.0014 11.4538 18.3694 11.8218 18.8233 11.8218H19.25C19.5031 11.8218 19.7084 12.0269 19.7084 12.2801V16.0417C19.7084 16.2948 19.5031 16.5 19.25 16.5H9.57764V15.5833H18.7917V12.7381C17.8462 12.7213 17.0848 11.9495 17.0848 10.9999C17.0848 10.0503 17.8462 9.2785 18.7917 9.26172V6.41667Z"
          fill="#32603A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.20817 6.41667H9.57745V5.5H2.74984C2.4967 5.5 2.2915 5.7052 2.2915 5.95833V9.71978C2.2915 9.97288 2.4967 10.1781 2.74984 10.1781H3.17655C3.63045 10.1781 3.9984 10.5461 3.9984 10.9999C3.9984 11.4538 3.63045 11.8218 3.17655 11.8218H2.74984C2.4967 11.8218 2.2915 12.0269 2.2915 12.2801V16.0417C2.2915 16.2948 2.4967 16.5 2.74984 16.5H9.57745V15.5833H3.20817V12.7381C4.15373 12.7213 4.91507 11.9495 4.91507 10.9999C4.91507 10.0503 4.15373 9.27859 3.20817 9.26172V6.41667Z"
          fill="#32603A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.01437 8.25823C8.02686 7.84167 8.36848 7.50781 8.78806 7.50781H10.3666C10.7862 7.50781 11.1278 7.84167 11.1403 8.25823C11.5073 8.06074 11.9673 8.18965 12.1771 8.55304L12.9664 9.92016C13.1762 10.2835 13.0579 10.7463 12.7033 10.9654C13.0579 11.1845 13.1762 11.6472 12.9664 12.0107L12.1771 13.3777C11.9673 13.7412 11.5073 13.8701 11.1403 13.6726C11.1279 14.0892 10.7863 14.4231 10.3666 14.4231H8.78806C8.36844 14.4231 8.02681 14.0892 8.01437 13.6726C7.64736 13.8701 7.1874 13.7412 6.9776 13.3777L6.18831 12.0107C5.9785 11.6472 6.09684 11.1845 6.45138 10.9654C6.09684 10.7463 5.9785 10.2835 6.18831 9.92016L6.9776 8.55304C7.1874 8.18965 7.64736 8.06074 8.01437 8.25823ZM8.93068 8.42448V9.05148C8.93068 9.21524 8.84332 9.36649 8.70151 9.44844C8.5597 9.5303 8.38499 9.5303 8.24318 9.44844L7.70015 9.13488L7.05347 10.2549L7.59651 10.5685C7.73832 10.6504 7.82567 10.8016 7.82567 10.9654C7.82567 11.1291 7.73832 11.2805 7.59651 11.3623L7.05347 11.6758L7.70015 12.7959L8.24318 12.4824C8.38499 12.4006 8.5597 12.4006 8.70151 12.4824C8.84332 12.5643 8.93068 12.7156 8.93068 12.8793V13.5064H10.224V12.8793C10.224 12.7156 10.3114 12.5643 10.4532 12.4824C10.595 12.4006 10.7697 12.4006 10.9115 12.4824L11.4545 12.7959L12.1012 11.6758L11.5582 11.3623C11.4164 11.2805 11.329 11.1291 11.329 10.9654C11.329 10.8016 11.4164 10.6504 11.5582 10.5685L12.1012 10.2549L11.4545 9.13488L10.9115 9.44844C10.7697 9.5303 10.595 9.5303 10.4532 9.44844C10.3114 9.36649 10.224 9.21524 10.224 9.05148V8.42448H8.93068Z"
          fill="#32603A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.57726 10.3229C9.20188 10.3229 8.89762 10.6272 8.89762 11.0025C8.89762 11.3778 9.20188 11.6821 9.57726 11.6821C9.95254 11.6821 10.2568 11.3778 10.2568 11.0025C10.2568 10.6272 9.95254 10.3229 9.57726 10.3229ZM7.98096 11.0025C7.98096 10.1209 8.69563 9.40625 9.57726 9.40625C10.4588 9.40625 11.1735 10.1209 11.1735 11.0025C11.1735 11.8841 10.4588 12.5987 9.57726 12.5987C8.69563 12.5987 7.98096 11.8841 7.98096 11.0025Z"
          fill="#32603A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6463 5.5C15.8994 5.5 16.1047 5.7052 16.1047 5.95833V6.79861C16.1047 7.05174 15.8994 7.25695 15.6463 7.25695C15.3931 7.25695 15.188 7.05174 15.188 6.79861V5.95833C15.188 5.7052 15.3931 5.5 15.6463 5.5ZM15.6463 8.02083C15.8994 8.02083 16.1047 8.22604 16.1047 8.47917V10.1597C16.1047 10.4129 15.8994 10.618 15.6463 10.618C15.3931 10.618 15.188 10.4129 15.188 10.1597V8.47917C15.188 8.22604 15.3931 8.02083 15.6463 8.02083ZM15.6463 11.382C15.8994 11.382 16.1047 11.5871 16.1047 11.8403V13.5208C16.1047 13.7739 15.8994 13.9792 15.6463 13.9792C15.3931 13.9792 15.188 13.7739 15.188 13.5208V11.8403C15.188 11.5871 15.3931 11.382 15.6463 11.382ZM15.6463 14.743C15.8994 14.743 16.1047 14.9483 16.1047 15.2014V16.0417C16.1047 16.2948 15.8994 16.5 15.6463 16.5C15.3931 16.5 15.188 16.2948 15.188 16.0417V15.2014C15.188 14.9483 15.3931 14.743 15.6463 14.743Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const Logout = () => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.3747 10.375H12.458C12.113 10.375 11.833 10.095 11.833 9.75C11.833 9.405 12.113 9.125 12.458 9.125H20.3747C20.7197 9.125 20.9997 9.405 20.9997 9.75C20.9997 10.095 20.7197 10.375 20.3747 10.375Z"
          fill="#F21C0E"
        />
        <path
          d="M17.2498 13.4997C17.0898 13.4997 16.9299 13.4388 16.8081 13.3164C16.564 13.0721 16.564 12.6763 16.8081 12.4322L19.4915 9.74892L16.8081 7.06551C16.564 6.82137 16.564 6.42556 16.8081 6.18142C17.0524 5.93713 17.4482 5.93713 17.6924 6.18142L20.8174 9.30642C21.0615 9.55056 21.0615 9.94637 20.8174 10.1905L17.6924 13.3155C17.5698 13.4388 17.4099 13.4997 17.2498 13.4997Z"
          fill="#F21C0E"
        />
        <path
          d="M7.66672 21C7.48834 21 7.31912 20.975 7.15005 20.9225L2.13495 19.2516C1.45258 19.0133 1 18.3775 1 17.6667V2.66672C1 1.74753 1.74753 1 2.66672 1C2.84494 1 3.01416 1.02502 3.18338 1.07751L8.19833 2.74835C8.88086 2.98669 9.33328 3.62253 9.33328 4.33328V19.3333C9.33328 20.2525 8.58591 21 7.66672 21ZM2.66672 2.25C2.43753 2.25 2.25 2.43753 2.25 2.66672V17.6667C2.25 17.8442 2.36917 18.0091 2.53915 18.0683L7.53076 19.7317C7.56662 19.7433 7.61331 19.75 7.66672 19.75C7.8959 19.75 8.08328 19.5625 8.08328 19.3333V4.33328C8.08328 4.15582 7.96411 3.99088 7.79413 3.93167L2.80252 2.26831C2.76666 2.25671 2.71997 2.25 2.66672 2.25Z"
          fill="#F21C0E"
        />
        <path
          d="M13.7086 7.66672C13.3636 7.66672 13.0836 7.38672 13.0836 7.04172V3.29172C13.0836 2.71753 12.6162 2.25 12.042 2.25H2.66699C2.32199 2.25 2.04199 1.97 2.04199 1.625C2.04199 1.28 2.32199 1 2.66699 1H12.042C13.3062 1 14.3336 2.02753 14.3336 3.29172V7.04172C14.3336 7.38672 14.0536 7.66672 13.7086 7.66672Z"
          fill="#F21C0E"
        />
        <path
          d="M12.0414 18.5007H8.70801C8.36301 18.5007 8.08301 18.2207 8.08301 17.8757C8.08301 17.5307 8.36301 17.2507 8.70801 17.2507H12.0414C12.6156 17.2507 13.083 16.7832 13.083 16.209V12.459C13.083 12.114 13.363 11.834 13.708 11.834C14.053 11.834 14.333 12.114 14.333 12.459V16.209C14.333 17.4732 13.3056 18.5007 12.0414 18.5007Z"
          fill="#F21C0E"
        />
      </svg>
    </>
  );
};
export const Search = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="10.3433"
          cy="10.3499"
          r="8.52962"
          stroke="#32603A"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.7319 16.7255L22.1862 22.1798"
          stroke="#32603A"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const PlusIcon = () => {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_1_14)" />
        <g clipPath="url(#clip0_1_14)">
          <path d="M15 15V9H17V15H23V17H17V23H15V17H9V15H15Z" fill="white" />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1_14"
            x1="-7.22581"
            y1="35.4909"
            x2="41.8522"
            y2="34.4918"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#42B03A" />
            <stop offset="1" stopColor="#3A883A" />
          </linearGradient>
          <clipPath id="clip0_1_14">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const CrossIcon = ({ size }) => {
  return (
    <>
      <svg
        width={size || "24"}
        height={size || "24"}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_159_7416)" />
        <g clipPath="url(#clip0_159_7416)">
          <path
            d="M11.9996 10.9395L15.7121 7.227L16.7726 8.2875L13.0601 12L16.7726 15.7125L15.7121 16.773L11.9996 13.0605L8.28706 16.773L7.22656 15.7125L10.9391 12L7.22656 8.2875L8.28706 7.227L11.9996 10.9395Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_159_7416"
            x1="-5.41936"
            y1="26.6182"
            x2="31.3891"
            y2="25.8689"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#42B03A" />
            <stop offset="1" stopColor="#3A883A" />
          </linearGradient>
          <clipPath id="clip0_159_7416">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(3 3)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const CheckMark = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.44442 7.40749C2.16828 7.40827 1.898 7.48721 1.66485 7.63518C1.43171 7.78315 1.24522 7.99411 1.12697 8.24365C1.00871 8.49319 0.963526 8.7711 0.996633 9.04525C1.02974 9.3194 1.13979 9.57857 1.31405 9.79278L5.02882 14.3434C5.16127 14.5078 5.33105 14.6383 5.52405 14.724C5.71706 14.8097 5.92772 14.848 6.13854 14.836C6.58943 14.8117 6.99651 14.5705 7.25605 14.174L14.9726 1.74651C14.9738 1.74445 14.9752 1.74239 14.9765 1.74036C15.0489 1.62919 15.0254 1.40888 14.876 1.27048C14.8349 1.23247 14.7865 1.20327 14.7338 1.18468C14.681 1.16608 14.625 1.15849 14.5692 1.16236C14.5134 1.16623 14.4589 1.18149 14.4092 1.20719C14.3596 1.23289 14.3156 1.26849 14.2802 1.3118C14.2775 1.31521 14.2746 1.31856 14.2717 1.32186L6.48946 10.1146C6.45985 10.1481 6.42389 10.1753 6.38366 10.1947C6.34343 10.2142 6.29973 10.2254 6.25512 10.2279C6.2105 10.2303 6.16585 10.2238 6.12376 10.2088C6.08167 10.1938 6.04297 10.1706 6.00992 10.1405L3.42715 7.7902C3.15891 7.5443 2.80831 7.40777 2.44442 7.40749Z"
          fill="#42B03A"
        />
      </svg>
    </>
  );
};

export const AddIcon = () => {
  return (
    <>
      <svg
        width="52"
        height="52"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_1_14)" />
        <g clipPath="url(#clip0_1_14)">
          <path d="M15 15V9H17V15H23V17H17V23H15V17H9V15H15Z" fill="white" />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1_14"
            x1="-7.22581"
            y1="35.4909"
            x2="41.8522"
            y2="34.4918"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#42B03A" />
            <stop offset="1" stopColor="#3A883A" />
          </linearGradient>
          <clipPath id="clip0_1_14">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const CloseIcon = () => {
  return (
    <>
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="26" cy="26" r="26" fill="#FF1C1C" />
        <g clipPath="url(#clip0_218_3335)">
          <path
            d="M26.0001 24.3098L31.9174 18.3926L33.6077 20.0829L27.6904 26.0001L33.6077 31.9174L31.9174 33.6077L26.0001 27.6904L20.0829 33.6077L18.3926 31.9174L24.3098 26.0001L18.3926 20.0829L20.0829 18.3926L26.0001 24.3098Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_218_3335">
            <rect
              width="28.6897"
              height="28.6897"
              fill="white"
              transform="translate(11.6553 11.6553)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const UploadIcon = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3794 2C12.7936 2 13.1294 2.33579 13.1294 2.75V14.791C13.1294 15.2052 12.7936 15.541 12.3794 15.541C11.9652 15.541 11.6294 15.2052 11.6294 14.791V2.75C11.6294 2.33579 11.9652 2 12.3794 2Z"
          fill="white"
          stroke="white"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.93414 11.3319C9.22763 11.0396 9.70251 11.0405 9.9948 11.334L12.3794 13.7284L14.764 11.334C15.0563 11.0405 15.5311 11.0396 15.8246 11.3319C16.1181 11.6242 16.1191 12.099 15.8268 12.3925L12.9108 15.3205C12.7701 15.4618 12.5788 15.5413 12.3794 15.5413C12.1799 15.5413 11.9887 15.4618 11.848 15.3205L8.93196 12.3925C8.63967 12.099 8.64064 11.6242 8.93414 11.3319Z"
          fill="white"
          stroke="white"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1237 7.189C16.1617 6.77654 16.5269 6.473 16.9393 6.51103C18.7866 6.68135 20.2856 7.12808 21.2552 8.43629C22.1848 9.69058 22.5005 11.5804 22.5005 14.2579C22.5005 17.8073 21.9436 19.9896 20.1201 21.1095C19.251 21.6432 18.1747 21.8791 16.9427 21.9937C15.7155 22.1079 14.2412 22.1079 12.5321 22.1079H12.4689C10.7593 22.1079 9.28477 22.1079 8.05747 21.9937C6.82534 21.8791 5.74907 21.6432 4.88007 21.1094C3.05676 19.9895 2.50049 17.8071 2.50049 14.2579C2.50049 11.5804 2.81594 9.69065 3.7454 8.43634C4.71485 7.12805 6.21394 6.68135 8.06165 6.51103C8.47411 6.47301 8.8393 6.77655 8.87732 7.18902C8.91534 7.60148 8.6118 7.96668 8.19933 8.0047C6.46704 8.16438 5.52613 8.55267 4.95058 9.32939C4.33503 10.1601 4.00049 11.6053 4.00049 14.2579C4.00049 17.8086 4.59872 19.1762 5.66516 19.8313C6.24103 20.185 7.04345 20.3929 8.19641 20.5001C9.34665 20.6072 10.753 20.6079 12.5005 20.6079C14.2474 20.6079 15.6536 20.6072 16.8037 20.5001C17.9566 20.3929 18.7591 20.185 19.3351 19.8313C20.4018 19.1762 21.0005 17.8084 21.0005 14.2579C21.0005 11.6054 20.6657 10.1601 20.0501 9.32943C19.4744 8.55264 18.5334 8.16437 16.8016 8.00469C16.3892 7.96666 16.0856 7.60146 16.1237 7.189Z"
          fill="white"
          stroke="white"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const ChatSendIcon = () => {
  return (
    <>
      <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="26" cy="26" r="26" fill="url(#paint0_linear_314_3216)" />
        <g clipPath="url(#clip0_314_3216)">
          <path
            d="M13.2012 22.8505C12.5885 22.6463 12.5827 22.3165 13.2129 22.1064L35.6136 14.6399C36.2345 14.4333 36.5901 14.7807 36.4164 15.3887L30.0155 37.7882C29.8395 38.409 29.4815 38.4302 29.2186 37.841L25.0007 28.3489L32.0423 18.96L22.6534 26.0016L13.2012 22.8505Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_314_3216"
            x1="-11.7419"
            y1="57.6727"
            x2="68.0098"
            y2="56.0492"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#42B03A" />
            <stop offset="1" stopColor="#3A883A" />
          </linearGradient>
          <clipPath id="clip0_314_3216">
            <rect
              width="28.1667"
              height="28.1667"
              fill="white"
              transform="translate(10.9174 11.918)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const UserIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0357 9.67064C11.2268 9.67064 12.2582 9.24341 13.1011 8.40049C13.9437 7.5577 14.3711 6.5265 14.3711 5.33518C14.3711 4.14427 13.9439 3.11293 13.101 2.26988C12.258 1.42723 11.2267 1 10.0357 1C8.84433 1 7.81313 1.42723 6.97035 2.27001C6.12756 3.1128 5.7002 4.14413 5.7002 5.33518C5.7002 6.5265 6.12756 7.55784 6.97035 8.40062C7.8134 9.24327 8.84474 9.67064 10.0357 9.67064ZM7.71631 3.01584C8.36299 2.36916 9.12159 2.05482 10.0357 2.05482C10.9496 2.05482 11.7083 2.36916 12.3551 3.01584C13.0018 3.66266 13.3163 4.4214 13.3163 5.33518C13.3163 6.24924 13.0018 7.00784 12.3551 7.65466C11.7083 8.30147 10.9496 8.61582 10.0357 8.61582C9.12187 8.61582 8.36327 8.30134 7.71631 7.65466C7.0695 7.00798 6.75501 6.24924 6.75501 5.33518C6.75501 4.4214 7.0695 3.66266 7.71631 3.01584Z"
          fill="#32603A"
        />
        <path
          d="M17.6216 14.8417C17.5973 14.491 17.5482 14.1084 17.4758 13.7043C17.4027 13.2973 17.3087 12.9125 17.1961 12.5608C17.0796 12.1973 16.9215 11.8383 16.7258 11.4943C16.523 11.1373 16.2846 10.8263 16.0171 10.5705C15.7374 10.3029 15.3949 10.0877 14.9988 9.93069C14.6041 9.77455 14.1667 9.69545 13.6989 9.69545C13.5151 9.69545 13.3374 9.77084 12.9942 9.99428C12.783 10.132 12.536 10.2913 12.2602 10.4675C12.0244 10.6177 11.705 10.7585 11.3104 10.8859C10.9255 11.0105 10.5347 11.0737 10.1488 11.0737C9.76316 11.0737 9.37232 11.0105 8.98712 10.8859C8.59298 10.7586 8.27342 10.6179 8.03804 10.4676C7.76489 10.2931 7.5177 10.1338 7.30333 9.99414C6.96043 9.77071 6.78272 9.69531 6.59898 9.69531C6.13096 9.69531 5.69371 9.77455 5.29916 9.93083C4.90338 10.0875 4.56075 10.3027 4.28074 10.5706C4.01322 10.8266 3.77482 11.1374 3.57212 11.4943C3.3767 11.8383 3.2185 12.1972 3.10205 12.5609C2.98958 12.9126 2.89551 13.2973 2.82245 13.7043C2.74994 14.1078 2.70091 14.4905 2.67661 14.8421C2.65271 15.1858 2.64062 15.5436 2.64062 15.905C2.64062 16.8446 2.93931 17.6053 3.52832 18.1663C4.11004 18.7198 4.87963 19.0005 5.81579 19.0005H14.4829C15.4188 19.0005 16.1883 18.7198 16.7702 18.1663C17.3593 17.6057 17.658 16.8448 17.658 15.9049C17.6579 15.5422 17.6457 15.1845 17.6216 14.8417ZM16.0429 17.402C15.6585 17.7679 15.1482 17.9457 14.4827 17.9457H5.81579C5.15016 17.9457 4.63985 17.7679 4.25561 17.4022C3.87864 17.0433 3.69544 16.5535 3.69544 15.905C3.69544 15.5677 3.70657 15.2347 3.72881 14.915C3.75051 14.6014 3.79487 14.2568 3.86065 13.8907C3.92561 13.5291 4.00828 13.1898 4.10661 12.8826C4.20095 12.588 4.32963 12.2963 4.4892 12.0153C4.6415 11.7475 4.81673 11.5178 5.01009 11.3327C5.19095 11.1595 5.41891 11.0178 5.68753 10.9115C5.93596 10.8132 6.21514 10.7593 6.51823 10.7512C6.55517 10.7709 6.62095 10.8084 6.72752 10.8778C6.94436 11.0192 7.1943 11.1804 7.4706 11.3568C7.78206 11.5554 8.18333 11.7348 8.66275 11.8895C9.15287 12.048 9.65275 12.1285 10.1489 12.1285C10.6451 12.1285 11.1451 12.048 11.6349 11.8897C12.1148 11.7346 12.5159 11.5554 12.8278 11.3566C13.1105 11.1758 13.3535 11.0193 13.5703 10.8778C13.6769 10.8085 13.7427 10.7709 13.7796 10.7512C14.0828 10.7593 14.362 10.8132 14.6106 10.9115C14.8791 11.0178 15.107 11.1596 15.2879 11.3327C15.4812 11.5177 15.6565 11.7474 15.8088 12.0155C15.9685 12.2963 16.0973 12.5881 16.1915 12.8824C16.29 13.19 16.3728 13.5292 16.4376 13.8906C16.5032 14.2574 16.5477 14.6021 16.5694 14.9152V14.9154C16.5918 15.2339 16.6031 15.5668 16.6032 15.905C16.6031 16.5536 16.4199 17.0433 16.0429 17.402Z"
          fill="#32603A"
        />
      </svg>
    </>
  );
};
export const LogOut = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_893_8100)">
          <path
            d="M18.5225 9.43324H11.3255C11.0119 9.43324 10.7573 9.17869 10.7573 8.86506C10.7573 8.55142 11.0119 8.29688 11.3255 8.29688H18.5225C18.8362 8.29688 19.0907 8.55142 19.0907 8.86506C19.0907 9.17869 18.8362 9.43324 18.5225 9.43324Z"
            fill="#F21C0E"
          />
          <path
            d="M15.6818 12.2727C15.5363 12.2727 15.3909 12.2173 15.2802 12.1061C15.0583 11.884 15.0583 11.5241 15.2802 11.3022L17.7197 8.86288L15.2802 6.42341C15.0583 6.20146 15.0583 5.84163 15.2802 5.61969C15.5023 5.3976 15.8621 5.3976 16.0841 5.61969L18.925 8.4606C19.1469 8.68254 19.1469 9.04237 18.925 9.26432L16.0841 12.1052C15.9727 12.2173 15.8273 12.2727 15.6818 12.2727Z"
            fill="#F21C0E"
          />
          <path
            d="M6.96983 19.092C6.80767 19.092 6.65384 19.0692 6.50014 19.0215L1.94095 17.5026C1.32061 17.2859 0.90918 16.7079 0.90918 16.0617V2.42535C0.90918 1.58973 1.58875 0.910156 2.42438 0.910156C2.5864 0.910156 2.74023 0.932906 2.89407 0.980624L7.45312 2.49957C8.0736 2.71624 8.48489 3.29427 8.48489 3.94041V17.5768C8.48489 18.4124 7.80546 19.092 6.96983 19.092ZM2.42438 2.04652C2.21603 2.04652 2.04554 2.217 2.04554 2.42535V16.0617C2.04554 16.223 2.15388 16.373 2.30841 16.4268L6.84624 17.939C6.87883 17.9495 6.92128 17.9556 6.96983 17.9556C7.17818 17.9556 7.34853 17.7851 7.34853 17.5768V3.94041C7.34853 3.77909 7.24019 3.62913 7.08566 3.57531L2.54783 2.06317C2.51524 2.05262 2.47279 2.04652 2.42438 2.04652Z"
            fill="#F21C0E"
          />
          <path
            d="M12.4624 6.97081C12.1488 6.97081 11.8942 6.71626 11.8942 6.40263V2.99354C11.8942 2.47155 11.4693 2.04652 10.9474 2.04652H2.42463C2.11099 2.04652 1.85645 1.79198 1.85645 1.47834C1.85645 1.1647 2.11099 0.910156 2.42463 0.910156H10.9474C12.0966 0.910156 13.0306 1.84427 13.0306 2.99354V6.40263C13.0306 6.71626 12.7761 6.97081 12.4624 6.97081Z"
            fill="#F21C0E"
          />
          <path
            d="M10.9467 16.8185H7.91633C7.60269 16.8185 7.34814 16.5639 7.34814 16.2503C7.34814 15.9366 7.60269 15.6821 7.91633 15.6821H10.9467C11.4687 15.6821 11.8936 15.2571 11.8936 14.7351V11.326C11.8936 11.0124 12.1481 10.7578 12.4618 10.7578C12.7754 10.7578 13.03 11.0124 13.03 11.326V14.7351C13.03 15.8843 12.096 16.8185 10.9467 16.8185Z"
            fill="#F21C0E"
          />
        </g>
        <defs>
          <clipPath id="clip0_893_8100">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ArrowLeft = () => {
  return (
    <>
      <svg
        width="12"
        height="20"
        viewBox="0 0 12 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0607 3.06066C11.6464 2.47488 11.6464 1.52513 11.0607 0.939341C10.4749 0.353554 9.52513 0.353553 8.93934 0.939338L11.0607 3.06066ZM2 9.99998L0.939341 8.93932C0.658036 9.22062 0.5 9.60215 0.5 9.99998C0.499999 10.3978 0.658034 10.7793 0.939338 11.0606L2 9.99998ZM8.93934 19.0607C9.52512 19.6464 10.4749 19.6464 11.0607 19.0607C11.6464 18.4749 11.6464 17.5251 11.0607 16.9393L8.93934 19.0607ZM8.93934 0.939338L0.939341 8.93932L3.06066 11.0606L11.0607 3.06066L8.93934 0.939338ZM0.939338 11.0606L4.93934 15.0606L7.06066 12.9393L3.06066 8.93932L0.939338 11.0606ZM4.93934 15.0606L8.93934 19.0607L11.0607 16.9393L7.06066 12.9393L4.93934 15.0606Z"
          fill="#2B383B"
        />
      </svg>
    </>
  );
};

export const FeatureUploadLogo = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8699 4.16953L14.5089 5.81253C14.6549 5.95953 14.8479 6.03353 15.0399 6.03353C15.2309 6.03353 15.4229 5.95953 15.5689 5.81453C15.8629 5.52153 15.8629 5.04653 15.5709 4.75353L12.6509 1.82553C12.3699 1.54253 11.8699 1.54253 11.5889 1.82553L8.66895 4.75353C8.37695 5.04653 8.37695 5.52153 8.67095 5.81453C8.96495 6.10653 9.43895 6.10653 9.73095 5.81253L11.3699 4.16953V7.15753C11.8799 7.14753 12.3799 7.14753 12.8699 7.15753V4.16953Z"
          fill="#2B383B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4 7.28735C15.28 7.20735 14.0999 7.16753 12.8699 7.15753L12.87 14.3973C12.87 14.8073 12.53 15.1473 12.12 15.1473C11.71 15.1473 11.37 14.8073 11.37 14.3973L11.3699 7.15753C10.1599 7.16753 8.9 7.21735 7.6 7.28735H7.58C3.55 7.65735 2.25 9.48735 2.25 14.7873C2.25 22.3873 5.1 22.3873 12 22.3873C18.9 22.3873 21.75 22.3873 21.75 14.7873C21.75 9.48735 20.45 7.65735 16.4 7.28735Z"
          fill="#2B383B"
        />
      </svg>
    </>
  );
};
